export const MUI_X_LICENSE_KEY =
  '348350ef8be868191eabce0269b0c36eTz0xMzM2MzcsRT0xODIyOTUzNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y';
